var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmClockAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7651 2.10998C16.4233 1.89838 15.9731 2.0013 15.7595 2.33985C15.5459 2.67841 15.6498 3.1244 15.9916 3.33599L19.8834 5.74562C20.2252 5.95722 20.6754 5.8543 20.889 5.51574C21.1026 5.17719 20.9987 4.7312 20.6569 4.5196L16.7651 2.10998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00844 3.33599C8.3502 3.1244 8.45409 2.67841 8.2405 2.33986C8.0269 2.0013 7.5767 1.89838 7.23494 2.10998L3.34307 4.5196C3.00131 4.7312 2.89742 5.17718 3.11102 5.51574C3.32461 5.8543 3.77481 5.95722 4.11657 5.74562L8.00844 3.33599Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4678 19.2585C20.0353 17.6388 21 15.432 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 15.432 3.96467 17.6388 5.53225 19.2585L4.32918 21.6646C4.14394 22.0351 4.29411 22.4856 4.66459 22.6708C5.03507 22.8561 5.48558 22.7059 5.67082 22.3354L6.70086 20.2753C8.1874 21.3599 10.019 22 12 22C13.981 22 15.8126 21.3599 17.2991 20.2753L18.3292 22.3354C18.5144 22.7059 18.9649 22.8561 19.3354 22.6708C19.7059 22.4856 19.8561 22.0351 19.6708 21.6646L18.4678 19.2585ZM12.75 8.00004V12.618L15.537 15.4765C15.8262 15.773 15.8202 16.2479 15.5236 16.537C15.227 16.8262 14.7522 16.8202 14.463 16.5236L11.463 13.4467C11.3264 13.3066 11.25 13.1187 11.25 12.9231V8.00004C11.25 7.58582 11.5858 7.25004 12 7.25004C12.4142 7.25004 12.75 7.58582 12.75 8.00004Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmClockAlt1);
export default __webpack_public_path__ + "static/media/alarm-clock-alt-1.019770f85323245e2856c32124107207.svg";
export { ForwardRef as ReactComponent };